<template>
  <div class="row min-h-screen shadow-none">
    <div class="col-lg-12">
      <div
        class="border-[1.5px] border-solid border-[#DBDCE0] rounded-[4px] w-full"
      >
        <div class="bg-[#FBFBFB] w-full">
          <p
            class="text-[#000000] text-[12px] leading-[18px] font-medium px-[24px] py-[14px]"
          >
            Settings Category
          </p>
          <div class="w-full bg-white flex flex-col justify-start">
            <div
              v-for="(item, index) in menuItems"
              :key="index"
              class="py-[10px] px-[24px] border-b w-full cursor-pointer"
              @click="navigateTo(item.route)"
            >
              <div
                class="max-w-[500px] w-full flex items-center justify-between"
              >
                <div class="flex gap-[14.5px] items-center">
                  <img
                    :src="item.icon"
                    :alt="item.label"
                    class="w-[48px] h-[48px]"
                  />
                  <p
                    class="text-[#353535] font-medium leading-[19.36px] text-[16px]"
                  >
                    {{ item.label }}
                  </p>
                </div>
                <div>
                  <span class="fa-solid fa-chevron-right cursor-pointer"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import SystemPermissions from "@/permissions";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settings",
  data() {
    return {
      menuItems: [
        {
          label: "Business Profile",
          icon: "/assets/icon/house.svg",
          route: "/settings/business",
        },
        // {
        //   label: "Billing",
        //   icon: "/assets/icon/billing.svg",
        //   route: "/settings/billings",
        // },
        {
          label: "End of Day Reports",
          icon: "/assets/icon/EOD.svg",
          route: "/settings/EODReport",
        },
        {
          label: "Discounts",
          icon: "/assets/icon/recieve.svg",
          route: "/settings/discounts",
        },
        {
          label: "Branches",
          icon: "/assets/icon/house.svg",
          route: "/settings/branch",
        },
        {
          label: "System Settings",
          icon: "/assets/icon/system.svg",
          route: "/settings/systemsettings",
        },
      ],
    };
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.logoImage {
  border-radius: 50%;
  width: 80px;
  height: 80px;
}
</style>
